import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { loadGatewayHistory } from '../lib/homeGatewayHistory'

export function useHomeGatewayHistory(userId, activity) {
  const [state, setState] = useState({ logs: [], loading: true, error: '' })
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let current = true
    setState({ logs: [], loading: true, error: '' })
    loadGatewayHistory(supabase, userId).then(logs => {
      if (current) setState({ logs, loading: false, error: '' })
    }).catch(() => {
      if (current) setState({ logs: [], loading: false, error: 'Wear history could not load. Retry to see your leading fragrances.' })
    })
    return () => { current = false }
  }, [userId, activity, attempt])
  return { ...state, retry: () => setAttempt(value => value + 1) }
}
